// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__392C9","header":"Messages_header__wG5TS"};